export const findNearestRuler = (newRate, rulers, total) => {
  let value;
  let percentage;
  newRate = newRate < 0 ? 0 : newRate;
  newRate = newRate > 100 ? 100 : newRate;
  if (newRate <= 0) {
    value = 0;
    percentage = 0;
  } else if (newRate >= 100) {
    value = total;
    percentage = 100;
  } else {
    let lowerRange = 0;
    let higherRange = 100;
    let lowerRuler = rulers[0];
    let higherRuler = rulers[total];
    for (let i = 0; i <= total; i++) {
      const ruler = rulers[i];

      if (ruler.percentage <= newRate) {
        lowerRange = ruler.percentage;
        lowerRuler = ruler;
      } else if (ruler.percentage > newRate) {
        higherRange = ruler.percentage;
        higherRuler = ruler;
        break;
      }
    }

    const lowerDiffer = newRate - lowerRange;
    const higherDiffer = higherRange - newRate;

    if (lowerDiffer <= higherDiffer) {
      value = lowerRuler.value;
      percentage = lowerRuler.percentage;
    } else {
      value = higherRuler.value;
      percentage = higherRuler.percentage;
    }
  }
  return [value, percentage];
};
export const addDragEventListeners = (target, touchstartHandler, touchendHandler, touchmoveHandler) => {
  if (!target) {
    return;
  }

  target.addEventListener('mouseout', touchendHandler);
  target.addEventListener('touchstart', touchstartHandler);
  target.addEventListener('touchend', touchendHandler);
  target.addEventListener('touchcancel', touchendHandler);
  target.addEventListener('touchmove', touchmoveHandler);
  target.addEventListener('mousedown', touchstartHandler);
  target.addEventListener('mouseup', touchendHandler);
  target.addEventListener('mousemove', touchmoveHandler);

};
export const removeDragEventListeners = (target, touchstartHandler, touchendHandler, touchmoveHandler) => {
  if (!target) {
    return;
  }

  target.removeEventListener('mouseout', touchendHandler);
  target.removeEventListener('touchstart', touchstartHandler);
  target.removeEventListener('touchend', touchendHandler);
  target.removeEventListener('touchcancel', touchendHandler);
  target.removeEventListener('touchmove', touchmoveHandler);
  target.removeEventListener('mousedown', touchstartHandler);
  target.removeEventListener('mouseup', touchendHandler);
  target.removeEventListener('mousemove', touchmoveHandler);
};

